import { render, staticRenderFns } from "./customerAttribution.vue?vue&type=template&id=814c5572&scoped=true&"
import script from "./customerAttribution.vue?vue&type=script&lang=js&"
export * from "./customerAttribution.vue?vue&type=script&lang=js&"
import style0 from "./customerAttribution.vue?vue&type=style&index=0&id=814c5572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814c5572",
  null
  
)

export default component.exports